import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../../context/LocaleContext'

const RoomSelectMiniFilter = ({onShowFilter}) => {
  const localeState = useLocaleState()
  return (
    <StyledContainer>
      <StyledHeader>{_L({key: 'Select a room', localeState})}</StyledHeader>
      <StyledFooter>
        <StyledLink onClick={onShowFilter}>
          {_L({key: 'Search options', localeState})}
        </StyledLink>
      </StyledFooter>
    </StyledContainer>
  )
}

export default RoomSelectMiniFilter

const StyledContainer = styled.div`
  background-color: white;
  box-sizing: border-box;
  position: relative;
`
const StyledHeader = styled.div`
  padding: 15px 20px 0 20px;
  font-size: 20px;
  font-weight: 600;
  box-sizing: border-box;
`
const StyledFooter = styled.div`
  padding: 10px 20px 15px 20px;
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
`
const StyledLink = styled.a`
  color: #3396fe;
  font-weight: 600;
  font-size: 14px;
  box-sizing: border-box;
`
